import { eventBus, streamHook } from './Streams';

const modalStateId = 'modal-state';

/**
 * Sets modal opened state
 * @param {string} modal
 * @param {boolean} opened
 */
export const setModalState = (modal, opened = false) =>
  eventBus.publish(`${modal}-${modalStateId}`, opened);

/**
 * Fetches modal opened state
 * @param {string} modal
 * @return {boolean}
 */
export const getModalState = (modal) =>
  streamHook(`${modal}-${modalStateId}`, false);

/**
 * Open modal
 * @param {string} modal
 */
const open = (modal) => setModalState(modal, true);

/**
 * Close modal
 * @param {string} modal
 */
const close = (modal) => setModalState(modal, false);

export const modal = {open, close};


/** WEBPACK FOOTER **
 ** ./data/ModalsStream.js
 **/